import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    seeRepaymentBreakdown: {
        id: '_.status_lines.see_repayment_breakdown',
        defaultMessage: 'Click here to see your repayment breakdown'
    },
    seeRepaymentSchedule: {
        id: '_.status_lines.see_repayment_schedule',
        defaultMessage: 'See repayment schedule'
    }
});
